import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";

var _createReducer;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import track from "./track";
import { recategorizeTransaction, setTransactionsFilter } from "../../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, recategorizeTransaction.success, function (state, payload, meta) {
  var category = meta.category,
      previousCategory = meta.previousCategory;

  var trackingState = _get(state, 'identity.tracking', null);

  var trackingData = {
    from_category: previousCategory,
    to_category: category
  };
  track('Transactions.Recategorize', trackingState, trackingData);
}), _defineProperty(_createReducer, setTransactionsFilter, function (state, meta) {
  var trackingState = _get(state, 'identity.tracking', null);

  track('Transactions.ChangeViewFilter', trackingState, _get(meta, 'filter'));
}), _createReducer));